import {
    Box,
    CardContent, Grid, Paper, Typography
} from "@mui/material";
import * as React from "react";
import DragDropOption from "./DragDropOption";
import QuestionDescription from "./QuestionDescription";

const QuestionDragDropSolution = ({question}) => {
    const categoriesDict = {};
    question["categories"].forEach(catg => categoriesDict[catg.id] = catg.name);
    const categories = {};
    question["options"].forEach(option => {
        if (categories[categoriesDict[option["category"]]])
            categories[categoriesDict[option["category"]]].push(option);
        else
            categories[categoriesDict[option["category"]]] = [option];
    });


    return (
        <Grid container justifyContent="center" alignItems="center" spacing={2}>
            <Grid item>
                <Paper elevation={10} sx={{m: 1, maxWidth: 1000}}>
                    <CardContent>
                        <QuestionDescription description={question["description"]}/>
                        {Object.keys(categories).map(catg =>
                            <Box>
                                <span>{catg}</span>
                                <Box sx={{border: 1, minHeight: 20}}
                                     id={catg}>
                                    {categories[catg].map(option => <DragDropOption option={option}
                                                                                    key={option.id}
                                                                                    id={option.id}/>)}
                                </Box>
                            </Box>
                        )}
                    </CardContent>
                </Paper>
            </Grid>
        </Grid>
    );
}

export default QuestionDragDropSolution;